import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { useI18n } from '@/providers/i18n';
import React from 'react';

type DescriptionDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  text: string;
};

export function DescriptionDialog({ open, onOpenChange, text }: DescriptionDialogProps) {
  const { t } = useI18n();
  const disabled = !String(text || '').trim();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg rounded-2xl bg-sidebar/95 backdrop-blur-2xl border-sidebar-border shadow-none p-4">
        <div className="space-y-4">
          <div className="space-y-1">
            <div className="text-base font-bold tracking-tight text-foreground/90">{t('Description')}</div>
            <div className="text-sm text-muted-foreground">{t('Parse image')}</div>
          </div>
          <div className="max-h-[50vh] overflow-auto rounded-xl border border-sidebar-border/30 bg-sidebar-accent/10 p-3 text-sm whitespace-pre-wrap break-words text-foreground/90">
            {String(text || '')}
          </div>
          <div className="flex items-center justify-end gap-2">
            <Button
              size="sm"
              variant="outline"
              className="rounded-lg"
              onClick={() => onOpenChange(false)}
            >
              {t('Close')}
            </Button>
            <Button
              size="sm"
              className="rounded-lg"
              onClick={() => {
                try {
                  const value = String(text || '');
                  if (!value) return;
                  if (navigator?.clipboard?.writeText) {
                    navigator.clipboard.writeText(value).then(
                      () => { try { toast.success(t('Copied')); } catch {} },
                      () => { try { toast.error(t('Server Request failed')); } catch {} }
                    );
                  } else {
                    const ta = document.createElement('textarea');
                    ta.value = value;
                    ta.style.position = 'fixed';
                    ta.style.left = '-10000px';
                    document.body.appendChild(ta);
                    ta.select();
                    try { document.execCommand('copy'); try { toast.success(t('Copied')); } catch {} } catch {}
                    document.body.removeChild(ta);
                  }
                } catch {}
              }}
              disabled={disabled}
            >
              {t('Copy')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}


